import { Controller } from "@hotwired/stimulus"
import { application } from "./application"

export default class extends Controller {
  async connect() {
    const { default: SaikoroTalkController } = await import("../wordwolf/saikoro_talk_controller")
    application.register("saikoro-talk", SaikoroTalkController)
  }
}
